import React from "react";
import ButtonsContainer from "../containers/ButtonsContainer";
import BreadcrumbsContainer from "../containers/BreadcrumbsContainer";

const AssetsHeader = () => (
    <div id="assets-header" className="socialpanelheader">
        <ButtonsContainer />
        <BreadcrumbsContainer />
    </div>
);

export default AssetsHeader;
